import { reportActionTypes } from '../constants/ApiContants';

const initialState = {  
  master_data: [],
  loading: false,
  staffsByLocation: null,
  patientList: [],
  reportsbytypecategory: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {  
  case reportActionTypes.get_masterdata.REQUEST:
    return {
      ...state,
      loading: true      
    };
  case reportActionTypes.get_masterdata.SUCCESS:
    return {
      ...state,
      loading: false,
      master_data: payload,
    };
  case reportActionTypes.get_Staff_ByLocation.REQUEST:  
    return {
      ...state,
      loading: true,
      staffsByLocation: null,      
    };
  case reportActionTypes.get_Staff_ByLocation.SUCCESS:
    return {
      ...state,
      loading: false,
      staffsByLocation: payload,
    };
  case reportActionTypes.get_patient.REQUEST:
    return {
      ...state,
      loading: true,
    };
  case reportActionTypes.get_patient.SUCCESS:
    return {
      ...state,
      patientList: payload,
      loading: false,
    };
  case reportActionTypes.get_reportsbytypecategory.REQUEST:  
    return {
      ...state,
      loading: true,
      reportsbytypecategory: null,      
    };
  case reportActionTypes.get_reportsbytypecategory.SUCCESS:
    return {
      ...state,
      loading: false,
      reportsbytypecategory: payload,
    };
  default:
    return {
      ...state,
    };
  }
};



// WEBPACK FOOTER //
// ./src/modules/Reports/reducers/index.js